// Feature-access helpers — mirror of backend stn_features.js keys.
// The startup's granted features come from `startup.featureAccess` (resolved by the
// backend so it's always a complete map). Core features are always allowed.

export const CORE_FEATURES = ['dashboard', 'notifications', 'settings'];

export function hasFeature(startup, key) {
  if (!key) return true;                 // unkeyed items are always shown
  if (CORE_FEATURES.includes(key)) return true;
  const fa = startup?.featureAccess;
  if (!fa) return true;                  // no map yet (legacy / loading) → don't block
  return !!fa[key];
}

// True if ANY of the given keys is granted (used for pages that host several
// independently-gated tabs, e.g. /mentors hosting Mentors + Batches + Assigned).
export function hasAnyFeature(startup, keys = []) {
  if (!keys.length) return true;
  return keys.some((k) => hasFeature(startup, k));
}
